import React from 'react';
import { SingleDragOption } from './shared/SingleDragOption';
import type { InlineDragOptionJSON } from '../../../transformers/zod-schemas';

export interface InlineDragOptionProps {
  /** The widget id — also used as the DnD optionId so the chip can be
   *  tracked across drops (e.g. "_inline_drag_opt_0"). */
  widgetId: string;
  widget: InlineDragOptionJSON;
}

/**
 * InlineDragOption — a single draggable chip rendered inline in text flow.
 */
export const InlineDragOption: React.FC<InlineDragOptionProps> = ({
  widgetId,
  widget,
}) => {

  return (
    <div className="inline-widget">
      <SingleDragOption
        optionId={widgetId}
        value={widget.value}
      />
    </div>
  );

};

